import styled, { keyframes, css } from 'styled-components';

const fadeOut = keyframes`
  0% { opacity: 1; }
  70% { opacity: 1; }
  100% { opacity: 0; }
`;

export const MessageContainer = styled.div<{ type: 'success' | 'error' }>`
  padding: 12px 16px;
  border-radius: 4px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  ${({ type }) =>
    type === 'success'
      ? css`
          background-color: #dff0d8;
          color: #3c763d;
          border: 1px solid #d6e9c6;
          animation: ${fadeOut} 3s forwards;
        `
      : css`
          background-color: #f2dede;
          color: #a94442;
          border: 1px solid #ebccd1;
        `}
`;
